import { Box, Checkbox, FormGroup } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

interface IFinancingTypeFilterProps {
    noInvoiceNorDeclaration: boolean;
    onChangeNoInvoiceNorDeclaration: (value: boolean) => void;
    onChangeOnlyDeclarations: (value: boolean) => void;
    onChangeOnlyInvoices: (value: boolean) => void;
    onlyDeclarations: boolean;
    onlyInvoices: boolean;
}

export function FinancingTypeFilter(props: IFinancingTypeFilterProps) {
    const language = getSelectedLanguage();

    return (
        <FormGroup
            label={language.finance.financingType}
            sx={{ alignItems: 'center', marginY: 5 }}
        >
            <Box
                display={'flex'}
                gap={9}
            >
                <Checkbox
                    checked={props.onlyDeclarations}
                    label={language.finance.declaration}
                    onChange={() => props.onChangeOnlyDeclarations(!props.onlyDeclarations)}
                />
                <Checkbox
                    checked={props.onlyInvoices}
                    label={language.finance.invoice}
                    onChange={() => props.onChangeOnlyInvoices(!props.onlyInvoices)}
                />
                <Checkbox
                    checked={props.noInvoiceNorDeclaration}
                    label={language.finance.noFinancing}
                    onChange={() => props.onChangeNoInvoiceNorDeclaration(!props.noInvoiceNorDeclaration)}
                />
            </Box>
        </FormGroup>
    );
}
